import { useState } from 'react'
import SectionHead from '../SectionHead/SectionHead'
import Card from '../../UI/Card'
import {FaQuoteLeft , FaArrowAltCircleRight , FaArrowAltCircleLeft} from 'react-icons/fa'
import { sliders } from '../../data';
import { useTranslation } from 'react-i18next';



import  './slider.css'
const Slider = () => {

	const {t} = useTranslation();

	const [index ,setIndex] = useState(0);
	const {photo} = sliders[index];
	
	const prevTestimonialHandler = () => {
		if ( index <= 0){
			setIndex(sliders.length - 1)
		}
		setIndex(prev => prev - 1)
	}
	const nextTestimonialHandler = () => {
		if(index >= sliders.length - 1){
			setIndex(0)
		}
		setIndex(prev => prev + 1)
	}

	return (
		<section className='slider'>
			<div className="container slider__container">
				<SectionHead  icon ={<FaQuoteLeft/>} title ={t('sliderTitle')} className ='testimonials__head'/>
				<Card className= "slider">
						<div className="slider__image">
                            <img src={photo} alt='' />
                        </div>
				</Card>
				<div className="slider__btn-container">
					<button className="slider__btn" onClick={prevTestimonialHandler}>{document.body.dir === "ltr"? <FaArrowAltCircleLeft/> :<FaArrowAltCircleRight/>}</button>
					<button className="slider__btn" onClick={nextTestimonialHandler}>{document.body.dir === "ltr"? <FaArrowAltCircleRight/>: <FaArrowAltCircleLeft/>}</button>
				</div>
			</div>
		</section>
	)
}

export default Slider;